function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icons8-html-5",
  d: "M82.847,4.239A3.722,3.722,0,0,0,80.076,3H8.037a3.721,3.721,0,0,0-3.7,4.129L12.53,80.868a3.715,3.715,0,0,0,2.675,3.166L43.03,91.983a3.679,3.679,0,0,0,2.046,0L72.9,84.034a3.72,3.72,0,0,0,2.675-3.166L83.77,7.129A3.706,3.706,0,0,0,82.847,4.239ZM65,30.639H31.777l.789,9.456H64.2L61.822,68.031,44.068,73.678l-.175-.056-17.558-5.6-.96-11.383h8.6l.376,4.423,9.809,2.161L53.8,61.06l1.023-11.952H24.728L22.4,21.6h43.37Z",
  transform: "translate(-4.317 -3)"
});

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.476,
    height: 89.128,
    viewBox: "0 0 79.476 89.128",
    transform: "translate(0 5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.91d02478.svg";
export { ForwardRef as ReactComponent };